export const checkHeadlineForSpecialChars = (headline: string) => {
  if (!headline) return headline;

  // check if any part of the headline is wrapped like that: %%text%%
  const regex = /%%(.*?)%%/g;
  const matches = headline.match(regex);
  if (matches) {
    return headline.split(regex).map((part, index) => {
      if (index % 2 === 0) {
        return <span key={index}>{part}</span>;
      } else {
        return <span key={index} className="special-string">{part}</span>;
      }
    });
  };
  return headline;
};